import React from "react";
import inputsValidation from "../../messages/inputValidation";

interface IProps {
  type: string;
  name: string;
  text: string;
  isLabel?: boolean;
  register: any;
  errors: any;
  defaultValue?: any;
}

const FormInput: React.FC<IProps> = ({ name, text, isLabel = false, type, register, errors, defaultValue }: IProps) => {
  return (
    <div className={"panel-form"} id={`input-${name}`}>
      {isLabel && (
        <label className={"label-input"} htmlFor={name}>
          {text}
        </label>
      )}
      <input type={type} placeholder={text} {...register} defaultValue={defaultValue} />
      {errors[name] && <span className={"input-error"}>*{inputsValidation(errors, name)}</span>}
    </div>
  );
};

export default FormInput;
